import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Moment from 'react-moment';

class ColumnFormatter extends Component {
    static asDate(cell, row) {

        if (cell === "0001-01-01T00:00:00+00:00" || cell === "" || cell === null)
            return "";

        return (new Date(cell).toLocaleDateString());
    }

    static asDateTime(cell, row) {
        if (cell === "0001-01-01T00:00:00+00:00")
            return "";

        return (<Moment fromNow date={cell} />);
    }

    static asCheckBox(cell, row) {
        return (
            <div>
                <input readOnly type="checkbox" checked={cell} />
            </div>
        );
    }

    static asAudio(cell, row) {

        if (!row.recordingUrl)
            return (<div>No recording</div>);

        return (
            <div>
                <audio controls width="100px" height="100px" src={row.recordingUrl} type="audio/mp3"></audio>
            </div>);
    }

    static editClientFormatter(cell, row, enumObject, rowIndex) {
        var id = row.clientId ? row.clientId : row.id;

        let url = '/applicant/' + id;
        return (<Link to={url}> {id} </Link>);
    }


}

export default ColumnFormatter;


// WEBPACK FOOTER //
// ./src/common/ColumnFormatter.js